import PropTypes from 'prop-types';
import { Modal } from 'antd';

const SIZE_TO_WIDTH = {
    sz: 360,
    md: 560,
    lg: 760,
};

/**
 * Global modal wrapper.
 * - Centered by default
 * - Size presets: sz (alerts), md (forms), lg (large forms)
 */
export const AppModal = ({ size = 'md', centered = true, width, ...props }) => {
    const resolvedWidth = width ?? SIZE_TO_WIDTH[size] ?? SIZE_TO_WIDTH.md;
    const { destroyOnClose, destroyOnHidden, ...rest } = props;
    const mask = {
        backdropFilter: 'blur(10px) saturate(140%)',
        WebkitBackdropFilter: 'blur(10px) saturate(140%)',
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        ...(rest?.styles?.mask || {}),
    };
    return (
        <Modal
            centered={centered}
            width={resolvedWidth}
            styles={{ ...(rest?.styles || {}), mask }}
            destroyOnHidden={typeof destroyOnHidden === 'boolean' ? destroyOnHidden : !!destroyOnClose}
            maskClosable={typeof rest.maskClosable === 'boolean' ? rest.maskClosable : false}
            {...rest}
        />
    );
};

AppModal.propTypes = {
    size: PropTypes.oneOf(['sz', 'md', 'lg']),
    centered: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

